import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { DATE_FORMAT } from '../../../constants/session';
import appConfig from '../../../appConfig';
import classNames from 'classnames';

const DateInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  userInput,
  error,
  setError,
  validateInput,
  hasTriedSubmitting,
}) => {
  //Effect to validate user input on submit
  useEffect(() => {
    if (hasTriedSubmitting > 0) validateInput(userInput);
  }, [hasTriedSubmitting]);

  //Effect to monitor changesin input
  useEffect(() => {
    if (userInput) setError('');
  }, [userInput]);

  return (
    <>
      <DatePicker
        className={classNames(error && 'input-error', 'form-control')}
        id={metaTag.meta.id}
        key={id}
        value={
          userInput
            ? format(userInput, appConfig.dateFormat || DATE_FORMAT)
            : ''
        }
        onChange={(date) => {
          handleInputChange(
            fileIndex,
            tagIndex,
            date || null
          );
          setError('');
        }}
        placeholderText={appConfig.dateFormat || DATE_FORMAT}
        onBlur={() => {
          validateInput(userInput);
        }}
      />
      {error && <div className="error-message">{error}</div>}
    </>
  );
};

export default DateInput;
